import React from 'react';
import { Icons, XIIcon } from '@inmoment/the-kitchen';

interface GraphicProps {
  icon: Icons;
}
export const GraphicIcon = (props: GraphicProps) => {
  const { icon } = props;

  return <XIIcon iconSize={96} icon={icon} />;
};
